import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '100%',
        height: '100%',
    },
    content: {
        width: '100%',
        height: '100%',
        textAlign: 'center'
    }
}))

export default useStyles
